module.exports = __webpack_public_path__ + "img/15_87.99ada9c0.png";